import styles from './Header.module.css';

const Header = () => {
  return (
    <header className={styles.header}>
      <h1>Damian</h1>
    </header>
  );
}

export default Header;